import React from "react";
import { useModalDialog } from "../../../hooks/useModalDialog";
import { DialogShell } from "../DialogShell";
import { PlainButton, PrimaryButton } from "../DistributionWizardFooter/DistributionWizardFooter.styles";
import { Row, RowLabel, Rows, RowValue, TestBand, TestLink, TestText, Thumb, Thumbs } from "./SendSummaryDialog.styles";
import type { SendSummaryDialogProps } from "./SendSummaryDialog.types";

/** A confirm that sums up what is about to go out: preview tiles, label/value rows, a test shortcut. */
export const SendSummaryDialog: React.FC<SendSummaryDialogProps> = ({
  open,
  title,
  description,
  thumbs,
  maxThumbs = 5,
  rows,
  testPrompt,
  testLabel,
  onSendTest,
  confirmLabel,
  cancelLabel,
  closeLabel,
  busy = false,
  onConfirm,
  onCancel,
}) => {
  const dialog = useModalDialog(open, onCancel);
  return (
    <DialogShell
      open={open}
      size="sm"
      width="32.5rem"
      radius="14"
      headerDivider={false}
      hideClose
      title={title}
      description={description}
      titleId="send-summary-title"
      descriptionId="send-summary-description"
      closeLabel={closeLabel}
      {...dialog}
      onClose={onCancel}
      footerEnd={
        <>
          <PlainButton onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </PlainButton>
          <PrimaryButton onClick={onConfirm} disabled={busy}>
            {confirmLabel}
          </PrimaryButton>
        </>
      }
    >
      {thumbs.length > 0 ? (
        <Thumbs aria-hidden="true" data-testid="summary-thumbs">
          {thumbs.slice(0, maxThumbs).map((thumb) => (
            <Thumb key={thumb.id}>{thumb.label}</Thumb>
          ))}
        </Thumbs>
      ) : null}
      <Rows>
        {rows.map((row) => (
          <Row key={row.label}>
            <RowLabel>{row.label}</RowLabel>
            <RowValue>{row.value}</RowValue>
          </Row>
        ))}
      </Rows>
      {onSendTest && testPrompt ? (
        <TestBand $tone="info">
          <TestText>{testPrompt}</TestText>
          <TestLink type="button" onClick={onSendTest} disabled={busy}>
            {testLabel}
          </TestLink>
        </TestBand>
      ) : null}
    </DialogShell>
  );
};

export default SendSummaryDialog;
